import { useState, useEffect, useCallback } from 'react';
import { fetchAgentDetails } from '../services/api';

/**
 * Custom hook for managing agent details
 * @param {number} agentId - Agent ID
 * @returns {Object} Agent details state and functions
 */
const useAgentDetails = (agentId) => {
  const [agentData, setAgentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Load agent details from API
   */
  const loadAgentDetails = useCallback(async () => {
    if (!agentId) {
      setAgentData(null);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      console.log('Fetching agent details for ID:', agentId);
      const data = await fetchAgentDetails(agentId);
      
      console.log('Agent details fetched:', data);
      setAgentData(data);
    } catch (err) {
      console.error('Error fetching agent details:', err);
      setError(err.message || 'Failed to load agent details');
      setAgentData(null);
    } finally {
      setLoading(false);
    }
  }, [agentId]);

  /**
   * Refresh agent details
   */
  const refreshAgentDetails = useCallback(() => {
    loadAgentDetails();
  }, [loadAgentDetails]);

  // Load agent details when agentId changes
  useEffect(() => {
    loadAgentDetails();
  }, [loadAgentDetails]);

  // Derived data
  const agentInfo = agentData?.agentInfo || null;
  const clientInfo = agentData?.clientInfo || { individual: [], corporate: [] };
  const flightInfo = agentData?.flightInfo || [];
  const whatsappNotifications = agentData?.whatsappNotifications || [];

  return {
    agentData,
    agentInfo,
    clientInfo,
    flightInfo,
    whatsappNotifications,
    loading,
    error,
    refreshAgentDetails
  };
};

export default useAgentDetails;
